// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .big {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  padding: 12px;
}
@media (max-width: 768px) {
  :host .big {
    padding: 12px 8px;
  }
}
:host .big .date {
  text-align: center;
  color: #1A1E29;
  margin-bottom: 12px;
}
:host .big .date h2 {
  font-weight: 500;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
}
:host .big .date h3 {
  color: #787D8B;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
:host .big .date h3 span:not(.date) {
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
:host .big .date h3 span.live {
  color: #3D923D;
  display: inline-flex;
}
:host .big .date h3 span.live:after {
  content: "";
  display: block;
  width: 4px;
  height: 4px;
  background-color: #3D923D;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(61, 146, 61, 0.2);
  align-self: flex-start;
  margin-left: 2px;
}
:host .big .scoreboard {
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
@media (max-width: 768px) {
  :host .big .scoreboard {
    order: 3;
    margin-top: 12px;
  }
}
:host .big .scoreboard .team {
  flex: 1 1 50%;
  display: flex;
  color: #383D4C;
}
:host .big .scoreboard .team img {
  flex: 0 0 72px;
  height: 72px;
  margin-right: 12px;
}
:host .big .scoreboard .team h4 {
  font-weight: 300;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 72px;
  line-height: 72px;
  text-transform: uppercase;
}
:host .big .scoreboard .team h4 span {
  display: block;
  font-weight: 500;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  line-height: 16px;
  text-transform: none;
  color: #787D8B;
}
:host .big .scoreboard .team .difference {
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 20px;
  line-height: 20px;
  display: flex;
  align-items: flex-start;
  padding-top: 12px;
  margin-left: 8px;
  opacity: 0;
}
:host .big .scoreboard .team .difference.less {
  opacity: 1;
  color: #E73F74;
}
:host .big .scoreboard .team .difference.less:before {
  content: "";
  display: inline-block;
  height: 20px;
  width: 20px;
  background-image: url("/assets/img/icons/color/arrow-evolution-down.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
:host .big .scoreboard .team .difference.more {
  opacity: 1;
  color: #A2D98C;
}
:host .big .scoreboard .team .difference.more:before {
  content: "";
  display: inline-block;
  height: 20px;
  width: 20px;
  background-image: url("/assets/img/icons/color/arrow-evolution-up.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
:host .big .scoreboard .team.visitor {
  flex-direction: row-reverse;
}
:host .big .scoreboard .team.visitor img {
  margin-left: 12px;
  margin-right: 0;
}
:host .big .scoreboard .team.visitor h4 {
  text-align: right;
}
@media (max-width: 768px) {
  :host .big .scoreboard .team .code, :host .big .scoreboard .team .difference {
    display: none;
  }
  :host .big .scoreboard .team img, :host .big .scoreboard .team.visitor img {
    height: 56px;
    flex-basis: 56px;
    display: block;
    margin: 0 auto;
  }
}
:host .big .scoreboard .result {
  color: #1A1E29;
  border-radius: 2px;
  margin: 0 auto;
  min-width: 260px;
}
@media (max-width: 768px) {
  :host .big .scoreboard .result {
    min-width: 194px;
  }
}
:host .big .scoreboard .result .score {
  display: flex;
  position: relative;
  background-color: #FFF;
  align-items: flex-start;
  justify-content: center;
}
:host .big .scoreboard .result .score:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  border-style: solid;
  border-width: 6px;
  border-color: transparent;
  border-radius: 50%;
  background-color: #FFF;
  transform: translate(-50%, -50%) rotateZ(45deg);
  transform-origin: center;
  transform-style: preserve-3d;
}
:host .big .scoreboard .result .score.quarter1:before {
  border-color: #787D8B transparent transparent transparent;
}
:host .big .scoreboard .result .score.quarter3:before {
  border-color: #787D8B #787D8B transparent transparent;
}
:host .big .scoreboard .result .score.quarter4:before {
  border-color: #787D8B #787D8B #787D8B transparent;
}
:host .big .scoreboard .result .score.quarter5:before, :host .big .scoreboard .result .score.quarter7:before {
  border-color: #787D8B;
}
:host .big .scoreboard .result .score:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 11px;
  height: 11px;
  border: 1px solid #787D8B;
  border-radius: 50%;
  transform-origin: center;
  transform: translate(-50%, -50%);
}
:host .big .scoreboard .result .score .full-score {
  display: none;
  font-weight: 700;
  font-family: "RM Neue";
  padding: 10px;
  line-height: 16px;
  font-size: 16px;
}
:host .big .scoreboard .result .score .full-score.home {
  padding-right: 0;
  text-align: right;
}
:host .big .scoreboard .result .score .full-score.visitor {
  padding-left: 0;
  text-align: left;
}
:host .big .scoreboard .result .score:not(.quarter7):not(.live) .full-score {
  display: initial;
}
:host .big .scoreboard .result .score:not(.quarter7):not(.live) .quarter-score {
  font-weight: 300;
  font-family: "RM Neue";
}
:host .big .scoreboard .result .score .quarter-score {
  flex: 1;
  text-align: center;
  font-weight: 700;
  font-family: "RM Neue";
  font-size: 56px;
  line-height: 56px;
  padding: 10px 0;
}
@media (max-width: 768px) {
  :host .big .scoreboard .result .score .quarter-score {
    line-height: 40px;
    font-size: 40px;
  }
}
:host .big .scoreboard .result .score .quarter-score + .quarter-score {
  border-left: 1px solid #E4E5E8;
}
:host .big .scoreboard .result > .time {
  background-color: #E4E5E8;
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
  padding: 2px;
}
:host .big .scoreboard .result > .time.live {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
}
:host .big .scoreboard .result > .time.live > * {
  flex: 1 1 33.33%;
}
:host .big .scoreboard .result > .time.live .quarter {
  text-align: left;
  white-space: nowrap;
}
:host .big .scoreboard .result > .time.live .time {
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 16px;
  line-height: 16px;
}
:host .big .scoreboard .result > .time.live .time ::ng-deep span {
  color: #787D8B;
  margin: 0 4px;
}
:host .big .scoreboard .result > .time.live.notstarted {
  background-color: #1A1E29;
  color: #C9CBD1;
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 18px;
  line-height: 20px;
  text-transform: none;
  letter-spacing: 0;
}
@media (max-width: 768px) {
  :host .big .scoreboard .result > .time.live.notstarted {
    font-size: 13px;
    line-height: 15px;
  }
}
:host .big .place {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #787D8B;
  font-size: 12px;
  line-height: 16px;
}
:host .big .place:before {
  content: "";
  display: inline-block;
  height: 20px;
  width: 20px;
  background-image: url("/assets/img/icons/ic_stadium.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-right: 8px;
}
:host .small {
  position: fixed;
  top: 0;
  width: 100%;
  color: #FFF;
  z-index: 1000;
}
:host .small.hidden {
  visibility: hidden;
}
:host .small .scoreboard {
  background: #292D3A;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
:host .small .scoreboard .container {
  width: 1200px;
}
:host .small .scoreboard .team {
  flex: 1;
  display: flex;
  align-items: center;
}
:host .small .scoreboard .team img {
  flex: 0 0 32px;
  height: 32px;
  margin-right: 12px;
}
:host .small .scoreboard .team .name {
  display: block;
  font-weight: 500;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  line-height: 36px;
  text-transform: none;
  color: #C9CBD1;
}
@media (max-width: 768px) {
  :host .small .scoreboard .team .name {
    display: none;
  }
}
:host .small .scoreboard .team .difference {
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: flex-start;
  margin-left: 8px;
  opacity: 0;
  padding: 10px 0;
}
:host .small .scoreboard .team .difference.less {
  opacity: 1;
  color: #E73F74;
}
:host .small .scoreboard .team .difference.less:before {
  content: "";
  display: inline-block;
  height: 16px;
  width: 16px;
  background-image: url("/assets/img/icons/color/arrow-evolution-down.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
:host .small .scoreboard .team .difference.more {
  opacity: 1;
  color: #A2D98C;
}
:host .small .scoreboard .team .difference.more:before {
  content: "";
  display: inline-block;
  height: 16px;
  width: 16px;
  background-image: url("/assets/img/icons/color/arrow-evolution-up.svg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
:host .small .scoreboard .team.visitor {
  flex-direction: row-reverse;
}
:host .small .scoreboard .team.visitor img {
  margin-left: 12px;
  margin-right: 0;
}
:host .small .scoreboard .team.visitor h4 {
  text-align: right;
}
@media (max-width: 768px) {
  :host .small .scoreboard .team img, :host .small .scoreboard .team.visitor img {
    margin: 0 12px;
  }
  :host .small .scoreboard .team .difference {
    margin: 0;
  }
}
:host .small .scoreboard .score {
  display: flex;
  position: relative;
  margin: 0 auto;
}
:host .small .scoreboard .score:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  border-style: solid;
  border-width: 4px;
  border-color: #787D8B;
  border-radius: 50%;
  transform: translate(-50%, -50%) rotateZ(45deg);
  transform-origin: center;
  transform-style: preserve-3d;
}
:host .small .scoreboard .score:not(.quarter7):not(.live) .full-score {
  display: initial;
}
:host .small .scoreboard .score:not(.quarter7):not(.live) .quarter-score {
  font-weight: 300;
  font-family: "RM Neue";
}
:host .small .scoreboard .score .full-score {
  display: none;
  font-weight: 700;
  font-family: "RM Neue";
  padding: 10px;
  line-height: 16px;
  font-size: 16px;
  min-width: 40px;
}
:host .small .scoreboard .score .full-score.home {
  padding-right: 0;
  text-align: right;
}
:host .small .scoreboard .score .full-score.visitor {
  padding-left: 0;
  text-align: left;
}
:host .small .scoreboard .score .quarter-score {
  font-weight: 700;
  font-family: "RM Neue";
  font-size: 32px;
  line-height: 32px;
  padding: 2px 13px;
  min-width: 80px;
}
:host .small .scoreboard .score .quarter-score + .quarter-score {
  border-left: 1px solid #787D8B;
}
:host .small .scoreboard .score .quarter-score.home {
  text-align: right;
}
:host .small .scoreboard .score .quarter-score.visitor {
  text-align: left;
}
:host .small .info {
  background: #1A1E29;
  text-align: center;
  color: #AEB1B9;
  font-size: 12px;
  font-weight: 700;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}
:host .small .info .container {
  padding: 0 6px;
  height: 36px;
}
:host .small .info .time {
  font-size: 10px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-align: center;
  padding: 2px;
  color: #F2F2F4;
  white-space: nowrap;
}
:host .small .info .time.live {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
}
:host .small .info .time.live .quarter {
  text-align: left;
}
:host .small .info .time.live .time {
  font-weight: 400;
  font-family: "RM Neue";
  font-size: 16px;
  line-height: 16px;
}
:host .small .info .time.live .time ::ng-deep span {
  color: #787D8B;
  margin: 0 4px;
}
:host .small .info .left {
  text-align: left;
  flex: 1 1 50%;
}
@media (max-width: 768px) {
  :host .small .info .left {
    white-space: nowrap;
  }
  :host .small .info .left span {
    display: none;
  }
}
:host .small .info .right {
  text-align: right;
  flex: 1 1 50%;
}
:host .small .info .right .date small {
  display: none;
  font-size: inherit;
}
@media (max-width: 768px) {
  :host .small .info .right .date {
    white-space: nowrap;
  }
  :host .small .info .right .date span {
    display: none;
  }
  :host .small .info .right .date small {
    display: initial;
  }
  :host .small .info .right .place {
    display: none;
  }
}
:host .small .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
:host .container {
  max-width: 1200px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/app/common/scoreboard/scoreboard.component.scss","webpack://./src/theme.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;AAFJ;AAGI;EALF;IAMI,iBAAA;EAAJ;AACF;AAEI;EACE,kBAAA;EACA,cCPM;EDQN,mBAAA;AAAN;AAEM;EC4CF,gBAAA;EAUA,+DAAA;EDpDI,eAAA;EACA,iBAAA;EACA,yBAAA;AACR;AAEM;EACE,cCbG;EDcH,eAAA;EACA,iBAAA;ECgCJ,gBAAA;EAYA,+DAAA;AD1CJ;AAEU;ECgCN,gBAAA;EAQA,+DAAA;ADtCJ;AACU;EACE,cCHA;EDIA,oBAAA;AACZ;AACY;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBCXF;EDYE,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,gBAAA;AACd;AAMI;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAJN;AAKM;EANF;IAOI,QAAA;IACA,gBAAA;EAFN;AACF;AAIM;EACE,aAAA;EACA,aAAA;EACA,cC3DG;ADyDX;AAIQ;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAFV;AAKQ;ECnBJ,gBAAA;EAcA,+DAAA;EDOM,eAAA;EACA,iBAAA;EACA,yBAAA;AAFV;AAIU;EACE,cAAA;ECtBR,gBAAA;EAUA,+DAAA;EDcQ,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cC5ED;AD2EX;AAKQ;ECjCJ,gBAAA;EAUA,sBAAA;EDyBM,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AAFV;AAIU;EACE,UAAA;EACA,cCzED;ADuEX;AAIY;EC9BV,WAAA;EACA,qBAAA;EACA,YD6BwF;EC5BxF,WD4B8F;EC3B9F,yEAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AD6BF;AADU;EACE,UAAA;EACA,cCnFA;ADsFZ;AADY;ECvCV,WAAA;EACA,qBAAA;EACA,YDsCsF;ECrCtF,WDqC4F;ECpC5F,uEAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AD2CF;AALQ;EACE,2BAAA;AAOV;AALU;EACE,iBAAA;EACA,eAAA;AAOZ;AAJU;EACE,iBAAA;AAMZ;AAFQ;EACE;IACE,aAAA;EAIV;EAFQ;IACE,YAAA;IACA,gBAAA;IACA,cAAA;IACA,cAAA;EAIV;AACF;AAAM;EACE,cC7II;ED8IJ,kBAAA;EACA,cAAA;EACA,gBAAA;AAER;AADQ;EALF;IAMI,gBAAA;EAIR;AACF;AAFQ;EACE,aAAA;EACA,kBAAA;EACA,sBC7IG;ED8IH,uBAAA;EACA,uBAAA;AAIV;AAFU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBC3JC;ED4JD,+CAAA;EACA,wBAAA;EACA,4BAAA;AAIZ;AADU;EACE,yDAAA;AAGZ;AAAU;EACE,qDAAA;AAEZ;AACU;EACE,iDAAA;AACZ;AAEU;EACE,qBCpLD;ADoLX;AAGU;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,gCAAA;AADZ;AAIU;EACE,aAAA;ECnJR,gBAAA;EAMA,sBAAA;ED+IQ,aAAA;EACA,iBAAA;EACA,eAAA;AADZ;AAEY;EACE,gBAAA;EACA,iBAAA;AAAd;AAEY;EACE,eAAA;EACA,gBAAA;AAAd;AAKY;EACE,gBAAA;AAHd;AAKY;EC5KR,gBAAA;EAYA,sBAAA;AD+JJ;AAMU;EACE,OAAA;EACA,kBAAA;EC7KR,gBAAA;EAMA,sBAAA;EDyKQ,eAAA;EACA,iBAAA;EACA,eAAA;AAHZ;AAIY;EAPF;IAQI,iBAAA;IACA,eAAA;EADZ;AACF;AAGY;EACE,8BAAA;AADd;AAMQ;EACE,yBC7OC;EA+CP,gBAAA;EAQA,+DAAA;EDwLM,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAHV;AAKU;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAHZ;AAKY;EACE,gBAAA;AAHd;AAMY;EACE,gBAAA;EACA,mBAAA;AAJd;AAOY;EC1NR,gBAAA;EAUA,sBAAA;EDkNU,eAAA;EACA,iBAAA;AAJd;AAMc;EACE,cC/QL;EDgRK,aAAA;AAJhB;AAQY;EACE,yBC1RF;ED2RE,cCnRH;EA4CP,gBAAA;EAUA,sBAAA;ED+NU,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;AALd;AAOc;EATF;IAUI,eAAA;IACA,iBAAA;EAJd;AACF;AAWI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cC3SK;ED4SL,eAAA;EACA,iBAAA;AATN;AAWM;EC/OJ,WAAA;EACA,qBAAA;EACA,YD8OkE;EC7OlE,WD6OwE;EC5OxE,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;ED0OM,iBAAA;AAFR;AAME;EACE,eAAA;EACA,MAAA;EACA,WAAA;EACA,WCnTS;EDoTT,aAAA;AAJJ;AAKI;EACE,kBAAA;AAHN;AAKI;EACE,mBCnUK;EDoUL,aAAA;EACA,8BAAA;EACA,mBAAA;AAHN;AAIM;EACE,aAAA;AAFR;AAKM;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AAHR;AAKQ;EACE,cAAA;EACA,YAAA;EACA,kBAAA;AAHV;AAMQ;EACE,cAAA;EClSN,gBAAA;EAUA,+DAAA;ED0RM,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,cCrVC;ADkVX;AAIU;EAPF;IAQI,aAAA;EADV;AACF;AAIQ;EC/SJ,gBAAA;EAUA,sBAAA;EDuSM,eAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AADV;AAGU;EACE,UAAA;EACA,cCvVD;ADsVX;AAGY;EC5SV,WAAA;EACA,qBAAA;EACA,YD2SwF;EC1SxF,WD0S8F;ECzS9F,yEAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AD4SF;AAFU;EACE,UAAA;EACA,cCjWA;ADqWZ;AAFY;ECrTV,WAAA;EACA,qBAAA;EACA,YDoTsF;ECnTtF,WDmT4F;EClT5F,uEAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AD0TF;AANQ;EACE,2BAAA;AAQV;AANU;EACE,iBAAA;EACA,eAAA;AAQZ;AALU;EACE,iBAAA;AAOZ;AAHQ;EACE;IACE,cAAA;EAKV;EAHQ;IACE,SAAA;EAKV;AACF;AADM;EACE,aAAA;EACA,kBAAA;EACA,cAAA;AAGR;AADQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBC/ZC;EDgaD,kBAAA;EACA,+CAAA;EACA,wBAAA;EACA,4BAAA;AAGV;AACU;EACE,gBAAA;AACZ;AACU;EC7XN,gBAAA;EAYA,sBAAA;ADoXJ;AAEQ;EACE,aAAA;EC7XN,gBAAA;EAMA,sBAAA;EDyXM,aAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AACV;AAAU;EACE,gBAAA;EACA,iBAAA;AAEZ;AAAU;EACE,eAAA;EACA,gBAAA;AAEZ;AAEQ;EC7YJ,gBAAA;EAMA,sBAAA;EDyYM,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AACV;AACU;EACE,8BAAA;AACZ;AAEU;EACE,iBAAA;AAAZ;AAEU;EACE,gBAAA;AAAZ;AAOI;EACE,mBC5dM;ED6dN,kBAAA;EACA,cCvdK;EDwdL,eAAA;ECvaF,gBAAA;EAQA,+DAAA;AD4ZJ;AAKM;EACE,cAAA;EACA,YAAA;AAHR;AAKM;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cCleG;EDmeH,mBAAA;AAHR;AAKQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AAHV;AAKU;EACE,gBAAA;AAHZ;AAMU;ECrcN,gBAAA;EAUA,sBAAA;ED6bQ,eAAA;EACA,iBAAA;AAHZ;AAKY;EACE,cC1fH;ED2fG,aAAA;AAHd;AAQM;EACE,gBAAA;EACA,aAAA;AANR;AAQQ;EAJF;IAKI,mBAAA;EALR;EAOQ;IACE,aAAA;EALV;AACF;AAQM;EACE,iBAAA;EACA,aAAA;AANR;AASU;EACE,aAAA;EACA,kBAAA;AAPZ;AAUQ;EACE;IACE,mBAAA;EARV;EAUU;IACE,aAAA;EARZ;EAUU;IACE,gBAAA;EARZ;EAWQ;IACE,aAAA;EATV;AACF;AAaI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAXN;AAcE;EACE,iBAAA;EACA,cAAA;AAZJ","sourcesContent":["@import 'theme';\n\n:host {\n  .big {\n    display: flex;\n    flex-direction: column;\n    justify-content: stretch;\n    padding: 12px;\n    @media (max-width: $mobileBreakpoint) {\n      padding: 12px 8px;\n    }\n\n    .date {\n      text-align: center;\n      color: $colorN100;\n      margin-bottom: 12px;\n\n      h2 {\n        @include font(medium);\n        font-size: 12px;\n        line-height: 16px;\n        text-transform: uppercase;\n      }\n\n      h3 {\n        color: $colorN50;\n        font-size: 14px;\n        line-height: 18px;\n        @include font();\n\n        span {\n          &:not(.date) {\n            @include font(bold);\n          }\n          &.live {\n            color: $colorLive;\n            display: inline-flex;\n\n            &:after {\n              content: '';\n              display: block;\n              width: 4px;\n              height: 4px;\n              background-color: $colorLive;\n              border-radius: 50%;\n              box-shadow: 0 0 0 2px transparentize($colorLive, .8);\n              align-self: flex-start;\n              margin-left: 2px;\n            }\n          }\n        }\n      }\n    }\n\n    .scoreboard {\n      flex: 1 1 auto;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 12px;\n      @media (max-width: $mobileBreakpoint) {\n        order: 3;\n        margin-top: 12px;\n      }\n\n      .team {\n        flex: 1 1 50%;\n        display: flex;\n        color: $colorN80;\n\n        img {\n          flex: 0 0 72px;\n          height: 72px;\n          margin-right: 12px;\n        }\n\n        h4 {\n          @include font(light);\n          font-size: 72px;\n          line-height: 72px;\n          text-transform: uppercase;\n\n          span {\n            display: block;\n            @include font(medium);\n            font-size: 14px;\n            line-height: 16px;\n            text-transform: none;\n            color: $colorN50;\n          }\n        }\n\n        .difference {\n          @include font(normal, condensed);\n          font-size: 20px;\n          line-height: 20px;\n          display: flex;\n          align-items: flex-start;\n          padding-top: 12px;\n          margin-left: 8px;\n          opacity: 0;\n\n          &.less {\n            opacity: 1;\n            color: $colorBad;\n\n            &:before {\n              @include pseudoElemIcon('/assets/img/icons/color/arrow-evolution-down.svg', 20px, 20px);\n            }\n          }\n\n          &.more {\n            opacity: 1;\n            color: $colorGood;\n\n            &:before {\n              @include pseudoElemIcon('/assets/img/icons/color/arrow-evolution-up.svg', 20px, 20px);\n            }\n          }\n        }\n\n        &.visitor {\n          flex-direction: row-reverse;\n\n          img {\n            margin-left: 12px;\n            margin-right: 0;\n          }\n\n          h4 {\n            text-align: right;\n          }\n        }\n\n        @media (max-width: $mobileBreakpoint) {\n          .code, .difference {\n            display: none;\n          }\n          img, &.visitor img {\n            height: 56px;\n            flex-basis: 56px;\n            display: block;\n            margin: 0 auto;\n          }\n        }\n      }\n\n      .result {\n        color: $colorN100;\n        border-radius: 2px;\n        margin: 0 auto;\n        min-width: 260px;\n        @media (max-width: $mobileBreakpoint) {\n          min-width: 194px;\n        }\n\n        .score {\n          display: flex;\n          position: relative;\n          background-color: $colorWhite;\n          align-items: flex-start;\n          justify-content: center;\n\n          &:before {\n            content: '';\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            display: block;\n            border-style: solid;\n            border-width: 6px;\n            border-color: transparent;\n            border-radius: 50%;\n            background-color: $colorWhite;\n            transform: translate(-50%, -50%) rotateZ(45deg);\n            transform-origin: center;\n            transform-style: preserve-3d;\n          }\n\n          &.quarter1:before {\n            border-color: $colorN50 transparent transparent transparent;\n          }\n\n          &.quarter3:before {\n            border-color: $colorN50 $colorN50 transparent transparent;\n          }\n\n          &.quarter4:before {\n            border-color: $colorN50 $colorN50 $colorN50 transparent;\n          }\n\n          &.quarter5:before, &.quarter7:before {\n            border-color: $colorN50;\n          }\n\n          &:after {\n            content: '';\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            display: block;\n            width: 11px;\n            height: 11px;\n            border: 1px solid $colorN50;\n            border-radius: 50%;\n            transform-origin: center;\n            transform: translate(-50%, -50%);\n          }\n\n          .full-score {\n            display: none;\n            @include font(bold, condensed);\n            padding: 10px;\n            line-height: 16px;\n            font-size: 16px;\n            &.home {\n              padding-right: 0;\n              text-align: right;\n            }\n            &.visitor {\n              padding-left: 0;\n              text-align: left;\n            }\n          }\n\n          &:not(.quarter7):not(.live) {\n            .full-score {\n              display: initial;\n            }\n            .quarter-score {\n              @include font(light, condensed);\n            }\n          }\n\n          .quarter-score {\n            flex: 1;\n            text-align: center;\n            @include font(bold, condensed);\n            font-size: 56px;\n            line-height: 56px;\n            padding: 10px 0;\n            @media (max-width: $mobileBreakpoint) {\n              line-height: 40px;\n              font-size: 40px;\n            }\n\n            & + .quarter-score {\n              border-left: 1px solid $colorN10;\n            }\n          }\n        }\n\n        & > .time {\n          background-color: $colorN10;\n          @include font(bold);\n          font-size: 10px;\n          line-height: 12px;\n          text-transform: uppercase;\n          letter-spacing: 1px;\n          text-align: center;\n          padding: 2px;\n\n          &.live {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 8px 12px;\n\n            & > * {\n              flex: 1 1 33.33%;\n            }\n\n            .quarter {\n              text-align: left;\n              white-space: nowrap;\n            }\n\n            .time {\n              @include font(normal, condensed);\n              font-size: 16px;\n              line-height: 16px;\n\n              ::ng-deep span {\n                color: $colorN50;\n                margin: 0 4px;\n              }\n            }\n\n            &.notstarted {\n              background-color: $colorN100;\n              color: $colorN20;\n              @include font(normal, condensed);\n              font-size: 18px;\n              line-height: 20px;\n              text-transform: none;\n              letter-spacing: 0;\n\n              @media (max-width: $mobileBreakpoint) {\n                font-size: 13px;\n                line-height: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .place {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: $colorN50;\n      font-size: 12px;\n      line-height: 16px;\n\n      &:before {\n        @include pseudoElemIcon('/assets/img/icons/ic_stadium.svg', 20px, 20px);\n        margin-right: 8px;\n      }\n    }\n  }\n  .small {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    color: $colorWhite;\n    z-index: 1000;\n    &.hidden {\n      visibility: hidden;\n    }\n    .scoreboard {\n      background: $colorN90;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      .container {\n        width: 1200px;\n      }\n\n      .team {\n        flex: 1;\n        display: flex;\n        align-items: center;\n\n        img {\n          flex: 0 0 32px;\n          height: 32px;\n          margin-right: 12px;\n        }\n\n        .name {\n          display: block;\n          @include font(medium);\n          font-size: 14px;\n          line-height: 36px;\n          text-transform: none;\n          color: $colorN20;\n          @media (max-width: $mobileBreakpoint) {\n            display: none;\n          }\n        }\n\n        .difference {\n          @include font(normal, condensed);\n          font-size: 16px;\n          line-height: 16px;\n          display: flex;\n          align-items: flex-start;\n          margin-left: 8px;\n          opacity: 0;\n          padding: 10px 0;\n\n          &.less {\n            opacity: 1;\n            color: $colorBad;\n\n            &:before {\n              @include pseudoElemIcon('/assets/img/icons/color/arrow-evolution-down.svg', 16px, 16px);\n            }\n          }\n\n          &.more {\n            opacity: 1;\n            color: $colorGood;\n\n            &:before {\n              @include pseudoElemIcon('/assets/img/icons/color/arrow-evolution-up.svg', 16px, 16px);\n            }\n          }\n        }\n\n        &.visitor {\n          flex-direction: row-reverse;\n\n          img {\n            margin-left: 12px;\n            margin-right: 0;\n          }\n\n          h4 {\n            text-align: right;\n          }\n        }\n\n        @media (max-width: $mobileBreakpoint) {\n          img, &.visitor img {\n            margin: 0 12px;\n          }\n          .difference {\n            margin: 0;\n          }\n        }\n      }\n\n      .score {\n        display: flex;\n        position: relative;\n        margin: 0 auto;\n\n        &:before {\n          content: '';\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          display: block;\n          border-style: solid;\n          border-width: 4px;\n          border-color: $colorN50;\n          border-radius: 50%;\n          transform: translate(-50%, -50%) rotateZ(45deg);\n          transform-origin: center;\n          transform-style: preserve-3d;\n        }\n\n        &:not(.quarter7):not(.live) {\n          .full-score {\n            display: initial;\n          }\n          .quarter-score {\n            @include font(light, condensed);\n          }\n        }\n\n        .full-score {\n          display: none;\n          @include font(bold, condensed);\n          padding: 10px;\n          line-height: 16px;\n          font-size: 16px;\n          min-width: 40px;\n          &.home {\n            padding-right: 0;\n            text-align: right;\n          }\n          &.visitor {\n            padding-left: 0;\n            text-align: left;\n          }\n        }\n\n        .quarter-score {\n          @include font(bold, condensed);\n          font-size: 32px;\n          line-height: 32px;\n          padding: 2px 13px;\n          min-width: 80px;\n\n          & + .quarter-score {\n            border-left: 1px solid $colorN50;\n          }\n\n          &.home {\n            text-align: right;\n          }\n          &.visitor {\n            text-align: left;\n          }\n\n        }\n      }\n\n    }\n    .info {\n      background: $colorN100;\n      text-align: center;\n      color: $colorN30;\n      font-size: 12px;\n      @include font(bold);\n      .container {\n        padding: 0 6px;\n        height: 36px;\n      }\n      .time {\n        font-size: 10px;\n        line-height: 12px;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n        text-align: center;\n        padding: 2px;\n        color: $colorN05;\n        white-space: nowrap;\n\n        &.live {\n          display: flex;\n          align-items: center;\n          justify-content: space-between;\n          padding: 8px 12px;\n\n          .quarter {\n            text-align: left;\n          }\n\n          .time {\n            @include font(normal, condensed);\n            font-size: 16px;\n            line-height: 16px;\n\n            ::ng-deep span {\n              color: $colorN50;\n              margin: 0 4px;\n            }\n          }\n        }\n      }\n      .left {\n        text-align: left;\n        flex: 1 1 50%;\n\n        @media (max-width: $mobileBreakpoint) {\n          white-space: nowrap;\n\n          span {\n            display: none;\n          }\n        }\n      }\n      .right {\n        text-align: right;\n        flex: 1 1 50%;\n\n        .date {\n          small {\n            display: none;\n            font-size: inherit;\n          }\n        }\n        @media (max-width: $mobileBreakpoint) {\n          .date {\n            white-space: nowrap;\n\n            span {\n              display: none;\n            }\n            small {\n              display: initial;\n            }\n          }\n          .place {\n            display: none;\n          }\n        }\n      }\n    }\n    .container {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n  }\n  .container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n}\n","$colorPrimary: #3E31FA;\n$colorPrimaryBg: #EEF2FD;\n$colorAccent: #1785FB;\n$colorSecondary: #C8B17B;\n\n$colorAdsBG: #0D0D0D;\n$colorBlack: #000;\n$colorN100: #1A1E29;\n$colorN90: #292D3A;\n$colorN80: #383D4C;\n$colorN70: #4B505F;\n$colorN60: #626775;\n$colorN50: #787D8B;\n$colorN40: #9397A2;\n$colorN30: #AEB1B9;\n$colorN20: #C9CBD1;\n$colorN10: #E4E5E8;\n$colorN05: #F2F2F4;\n$colorWhite: #FFF;\n\n$colorBestPlayer: #F2B701;\n$colorDisabled: $colorN30;\n\n$gridRampComp1: #FFFFFF;\n$gridRampComp2: #FFFFCC;\n$gridRampComp3: #A1DAB4;\n$gridRampComp4: #41B6C4;\n$gridRampComp5: #2C7FB8;\n$gridRampComp6: #253494;\n\n$colorGood: #A2D98C;\n$colorBad: #E73F74;\n$colorLive: #3D923D;\n$colorLiveTooltip: #A2D98C;\n\n$colorNotFound: #DC0032;\n$colorBackgroundTooltip: #0F2145;\n\n$colorGreyPlacehold: #8C95A6;\n$colorGreyTitle: #0F2145;\n$colorGreyLabel: #5E6A83;\n$colorGreyDark: #29395A;\n$colorGreyOffWhite: #FBFDFF;\n$colorGreyOffBlack: #14142B;\n$animationTimeSlow: 2s;\n$animationTimeNormal: 1s;\n$animationTimeFast: .5s;\n$animationTimeBlink: .1s;\n$animationFuncDefault: ease-out;\n$animationFuncAlt: linear;\n\n$mobileBreakpoint: 768px;\n\n@mixin font($weight: normal, $condensed: false) {\n  @if $weight == extra-light {\n    font-weight: 200;\n  } @else if $weight == light {\n    font-weight: 300;\n  } @else if $weight == normal {\n    font-weight: 400;\n  } @else if $weight == medium {\n    font-weight: 500;\n  } @else if $weight == bold {\n    font-weight: 700;\n  } @else if $weight == black {\n    font-weight: 900;\n  }\n\n  @if $condensed == condensed {\n    font-family: 'RM Neue';\n  } @else {\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n  }\n}\n\n@mixin pseudoElemIcon($file, $height, $width) {\n  content: '';\n  display: inline-block;\n  height: $height;\n  width: $width;\n  background-image: url($file);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n@mixin noselect() {\n  -webkit-touch-callout: none;\n    -webkit-user-select: none;\n     -khtml-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n@mixin button($file: null) {\n  border: none;\n  cursor: pointer;\n  display: flex;\n  padding: 12px 20px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  background: linear-gradient(8deg, #3E31FA 19.1%, #8760F6 94.27%);\n  color: $colorGreyOffWhite;\n  @include font(medium);\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n\n  @if $file != null {\n    &::before {\n      @include pseudoElemIcon($file, 16px, 16px);\n    }\n  }\n}\n\n@mixin headingH3() {\n  @include font(bold);\n  font-size: 32px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyOffBlack;\n  text-align: center;\n}\n@mixin headingH5() {\n  @include font(normal);\n  font-size: 24px;\n  font-style: normal;\n  letter-spacing: -0.5px;\n  margin-bottom:16px;\n  color: $colorGreyDark;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
